import HtmlTemplateEditor from "./HtmlTemplateEditor";
import {useCreateTemplateMutation} from "../../../../services/templates";
import {toast} from "react-toastify";
import {Divider, Typography} from "@mui/material";
import * as React from "react";

export default function AddTemplate() {

  const [createTemplate] = useCreateTemplateMutation();

  const onSave = async (title: string, html: string, design: any) => {
    try {
      await createTemplate({name: title, text: html, design}).unwrap();
      toast.success("Template created successfully.");
    } catch (e) {
      toast.error("Failed to create template, please try again.")
    }
  }

  return (
    <>
      <Typography variant="h4" component="div" sx={{fontWeight: 600}}>
        <b>Add new template</b>
      </Typography>

      <Divider sx={{my: 2}}/>
      <HtmlTemplateEditor title="new template" onSave={onSave}/>
    </>
  )
}